import * as React from 'react'

import type { Brief } from '@disco/types/types/brief'

import { useMenu } from 'components/ds'

type Props = {
  brief: Brief
  editMode?: boolean
  briefWorkflowV2Enabled: boolean
  canShareBrief: boolean
  closing: boolean
  reopening: boolean
  handleShare: () => void
  handleEditBrief: () => void
  handleDuplicate: () => void
  handleManageBriefAccess: () => void
  handleBriefSettings: () => void
  handleReopenBrief: () => void
  handleCloseBrief: () => void
  handleDelete: () => void
}

/**
 * The brief menu items, shared by the three-dot menu and the row's
 * right-click menu so the two can never drift apart.
 */
const BriefMenuBody = ({
  brief,
  editMode,
  briefWorkflowV2Enabled,
  canShareBrief,
  closing,
  reopening,
  handleShare,
  handleEditBrief,
  handleDuplicate,
  handleManageBriefAccess,
  handleBriefSettings,
  handleReopenBrief,
  handleCloseBrief,
  handleDelete,
}: Props): React.ReactNode => {
  const Menu = useMenu()

  return (
    <>
      {briefWorkflowV2Enabled && (
        <Menu.Item
          disabled={!canShareBrief}
          onClick={canShareBrief ? handleShare : undefined}
        >
          Share
        </Menu.Item>
      )}
      {!editMode && <Menu.Item onClick={handleEditBrief}>Edit brief</Menu.Item>}
      <Menu.Item onClick={handleDuplicate}>Duplicate</Menu.Item>
      <Menu.Item onClick={handleBriefSettings}>Brief settings</Menu.Item>
      {briefWorkflowV2Enabled &&
        (brief.status === 'sent' || brief.sent_status) && (
          <Menu.Item onClick={handleManageBriefAccess}>Manage access</Menu.Item>
        )}
      {briefWorkflowV2Enabled &&
        brief?.submission_status === 'closed' &&
        brief?.publishing_status !== 'draft' && (
          <Menu.Item onClick={handleReopenBrief} disabled={reopening}>
            {reopening ? 'Reopening brief...' : 'Reopen brief'}
          </Menu.Item>
        )}
      {briefWorkflowV2Enabled &&
        brief?.submission_status !== 'closed' &&
        brief?.publishing_status !== 'draft' && (
          <Menu.Item onClick={handleCloseBrief} disabled={closing}>
            {closing ? 'Closing brief...' : 'Close brief'}
          </Menu.Item>
        )}
      <Menu.Item color="red" onClick={handleDelete}>
        Delete brief
      </Menu.Item>
    </>
  )
}

export default BriefMenuBody
